import { render, staticRenderFns } from "./BuyerDashboard.vue?vue&type=template&id=78c593eb&scoped=true"
import script from "./BuyerDashboard.vue?vue&type=script&lang=js"
export * from "./BuyerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c593eb",
  null
  
)

export default component.exports